// components/Info.js
import React from 'react';
import { Container, Segment, Header, Button, Divider } from 'semantic-ui-react';

const Info = ({ onNext }) => {
  return (
    <Container>
      <Segment padded>
        <Header as="h1" textAlign="center">Kişilik Analizi Testine Hoş Geldiniz!</Header>

        <p><strong>Quders Kişilik Analizi Testi</strong></p>
        <p>
          Kişilik tipinizi öğrenmek ilişkileriniz, kariyeriniz, başarılarınız, tekrarlayan sorunlarınız, kararlarınız ve geleceğiniz ile ilgili size önemli bir veri sunar.
        </p>
        <p>
          Quders Kişilik Analizi Testi ile kişilik tipinizi hızla öğrenebilirsiniz.
        </p>

        <Divider />

        <Header as="h3">TESTİ ÇÖZERKEN DİKKAT ETMENİZ GEREKENLER</Header>

        <ul style={{ lineHeight: '1.8' }}>
          <li>Her cümle size yakın gelebilir. Çünkü bu ifadeler sizde az ya da çok bulunur.</li>
          <li>İfadeleri olmak istediğiniz kişiye göre değil, günlük yaşamda çoğunlukla nasıl davrandığınızı düşünerek değerlendirin. <strong>Yalnızca sizi belirgin biçimde tanımlayan</strong> ifadeleri işaretleyin. <strong>BİRDEN FAZLA İFADE</strong> işaretleyebilirsiniz.</li>
          <li>Her ifadenin sizde var olabileceğini hatırlatalım ama amacınız sizi <strong>en iyi tanımlayan</strong> ifadeyi bulmak :)</li>
          <li>Tanımları okurken kendinize odaklanın. Sessiz bir ortam tercih edin. Test yaklaşık 20 dakika sürmektedir.</li>
          <li>Bazen testi çözen katılımcılar <strong>olmak istedikleri</strong> veya <strong>dışardan kendilerine atfedilen</strong> kişilik tiplerini düşünerek ifadeleri yanıtlayabilirler. Kendinize odaklanmanız önemlidir.</li>
          <li>Testte doğru veya yanlış cevap yoktur. Bu yüzden ifadelerin sizi tam olarak tanımlamasına özen gösterin.</li>
        </ul>

        <p><strong>Testinize ilişkin yanıtların sonucunda raporunuz paylaştığınız e-mail adresine iletilecektir.</strong></p>

        <Header as="h3" textAlign="center">Hadi teste başlayalım 🙂</Header>

        <Button primary fluid size="large" onClick={onNext} style={{ marginTop: 30 }}>
          Devam Et
        </Button>
      </Segment>
    </Container>
  );
};

export default Info;
